module.exports = __webpack_public_path__ + "img/ktb-logo.5199412c.png";